var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"animation",staticClass:"animation",class:_vm.color ? _vm.color + '--text' : ''})}
var staticRenderFns = []

export { render, staticRenderFns }